module.exports = __webpack_public_path__ + "static/media/BentonSansCond-Regular.43cd4ac7.otf";